import React from 'react';
import { FEATURED_IMAGES } from 'src/data';
import './FeaturedContent.css';

export const FeaturedContent = () => {
  // can be exported as custom utils function with images array as arg
  const today = new Date();
  const imageNumber = today.getMonth() % 3;
  const featuredImageURL = FEATURED_IMAGES[imageNumber].url.toString();
  const featuredImageName = FEATURED_IMAGES[imageNumber].name.toString();
  return (
    <main>
      <img src={featuredImageURL} className='lnl-featured' alt={`Featured: ${featuredImageName}`} />
    </main>
  );
};
